var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 37,
    viewBox: "0 0 30 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9463 19.502C24.9642 18.1055 25.3348 16.7362 26.0235 15.5216C26.7122 14.307 27.6966 13.2865 28.8852 12.5551C28.1301 11.4757 27.134 10.5873 25.976 9.96067C24.8179 9.334 23.5299 8.98625 22.2141 8.94504C19.4072 8.65014 16.6862 10.6262 15.2559 10.6262C13.7979 10.6262 11.5957 8.97432 9.22434 9.02316C7.69047 9.07277 6.1956 9.51924 4.88536 10.3191C3.57513 11.1189 2.49422 12.2449 1.74796 13.5872C-1.48467 19.1895 0.926581 27.423 4.02318 31.9514C5.57247 34.1689 7.38315 36.6459 9.75238 36.558C12.0708 36.4618 12.9367 35.0782 15.7353 35.0782C18.5078 35.0782 19.3202 36.558 21.7375 36.5022C24.2253 36.4618 25.7928 34.2749 27.2877 32.0364C28.4009 30.4564 29.2574 28.7101 29.8257 26.8623C28.3804 26.2504 27.1469 25.2261 26.2792 23.9173C25.4115 22.6084 24.9479 21.0728 24.9463 19.502Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3787 5.96667C21.7351 4.33671 22.4034 2.24167 22.2416 0.126465C20.1692 0.344339 18.255 1.33576 16.8802 2.90318C16.208 3.66891 15.6932 4.55974 15.3652 5.52474C15.0372 6.48974 14.9024 7.51 14.9685 8.52717C16.0051 8.53786 17.0305 8.31297 17.9676 7.86945C18.9048 7.42593 19.7292 6.77533 20.3787 5.96667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightAppleLogo);
export default __webpack_public_path__ + "static/media/light-apple-logo.bf620a32b6153e2239b9aeb88acf64d6.svg";
export { ForwardRef as ReactComponent };